import { DataService } from 'api/DataService'
import { parseCookies } from 'nookies'

import { ProductAutocomplete } from 'components/AutocompleteProducts/AutocompleteProducts'

export type ExtraFields = {
  created_at: string
  extra_fieldable_type: string
  name: string
  required: boolean
  status: string
  updated_at: string
  uuid: string
}

export type Data = {
  products: ProductAutocomplete[]
  customerData: string[]
  userData: string[]
  dateData: string[]
  recurrenceData: string[]
  billingData: string[]
}

const getExtraFields = async (merchantUuid: string) => {
  const response = await DataService({
    type: 'GET',
    url: `/v1/merchants/${merchantUuid}/link_customer`
  })
  return response?.data?.record?.extra_fields as ExtraFields[]
}

const customerVariables = [
  'Nome completo do cliente',
  'Identificador interno',
  'Documento do cliente',
  'Endereço do cliente',
  'Email do cliente',
  'Telefone do cliente'
]

const dateVariables = ['Data atual', 'Data atual por extenso']

const recurrenceVariables = [
  'Itens da composição da recorrência',
  'Quantidade dos itens da recorrência',
  'Valor total da recorrência',
  'Valor total da recorrência por extenso',
  'Frequência da recorrência',
  'Ciclo atual da recorrência',
  'Total de ciclos da recorrência',
  'Total de ciclos da recorrência por extenso',
  'Dia de vencimento da recorrência',
  'Forma de pagamento da recorrência',
  'Forma de pagamento utilizada na recorrência',
  'Juros ao mês da recorrência (%)',
  'Multa da recorrência (%)',
  'Desconto da recorrência',
  'Descrição da recorrência',
  'Bonificação da recorrência',
  'Data do primeiro ciclo da recorrência',
  'Data do último ciclo da recorrência'
]

const billingVariables = [
  'Itens da composição da cobrança',
  'Quantidade dos itens da cobrança',
  'Valor total da cobrança',
  'Valor total da cobrança por extenso',
  'Forma de pagamento da cobrança',
  'Forma de pagamento utilizada na cobrança',
  'Juros ao mês da cobrança (%)',
  'Multa da cobrança (%)',
  'Desconto da cobrança',
  'Descrição da cobrança',
  'Bonificação da cobrança',
  'Data de vencimento da cobrança'
]

export const getPJVariables = async (uuid: string) => {
  const products = await getProducts()
  const extra_fields = await getExtraFields(uuid)
  const userVariables = [
    'Razão social',
    'Nome fantasia',
    'CNPJ',
    'Endereço',
    'Email',
    'Telefone',
    'Data de fundação'
  ]
  return {
    products: products,
    customerData: [
      ...customerVariables,
      ...(extra_fields ? extra_fields.map((field) => field.name) : [])
    ],
    userData: [...userVariables],
    dateData: [...dateVariables],
    recurrenceData: recurrenceVariables,
    billingData: billingVariables
  }
}
export const getPFVariables = async (uuid: string) => {
  const products = await getProducts()
  const extra_fields = await getExtraFields(uuid)
  const userVariables = [
    'Nome completo',
    'CPF',
    'Endereço',
    'Email',
    'Telefone',
    'Data de nascimento'
  ]
  return {
    products: products,
    customerData: [
      ...customerVariables,
      ...['divider'],
      ...(extra_fields ? extra_fields.map((field) => field.name) : [])
    ],
    userData: [...userVariables],
    dateData: [...dateVariables],
    recurrenceData: recurrenceVariables,
    billingData: billingVariables
  }
}

export const isCNPJ = () => {
  const { ['nextauth.document']: document } = parseCookies()
  if (document.length === 14) return true
  return false
}

const getProducts = async () => {
  const response = await DataService({
    type: 'GET',
    url: '/v1/products_autocomplete'
  })
  return response?.data?.records as ProductAutocomplete[]
}

export const handleGetRichTextEditorVariables = async (): Promise<Data> => {
  const { ['nextauth.uuid']: uuid } = parseCookies()

  if (isCNPJ()) {
    return await getPJVariables(uuid)
  } else {
    return await getPFVariables(uuid)
  }
}
